import * as React from 'react';
import { withRouter, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import * as queryString from 'query-string';
import { useDynamicValues } from '@doordash/component-dynamic-values';
import { fetchMembers, addAdminRole, removeAdminRole } from './members_slice';
import { getStatusForAction as getStatusForMembersAction, getMembers, getMembersPagination, } from '../selectors/members_selector';
import { getCurrentTeamMember, getTeamId } from '../selectors/portal_selector';
import { getSelectedTeamAccountContent } from '../selectors/uiSelector';
import { INITIAL_FETCH_STATUS } from '../constants/fetch_status';
import { MembersActions } from '../constants/actions';
import { DEFAULT_PAGE_SIZE } from '../constants/values';
import { DASHPASS_STATUS } from '../types/dashpass';
import AdminMembers from './admin_members';
import { DYNAMIC_VALUES_NAME } from './DynamicValues';
import { MemberRoles as Roles, } from '../types/members';
export var AdminMembersContainer = function (_a) {
    var _b;
    var _c = _a.match.params, teamAccountId = _c.teamAccountId, _d = _c.page, page = _d === void 0 ? '1' : _d, search = _a.location.search, history = _a.history;
    var dispatch = useDispatch();
    var teamId = useSelector(getTeamId) || '';
    var selectedTeamAccount = useSelector(getSelectedTeamAccountContent);
    var hasDashPassForSelectedAccount = ((_b = selectedTeamAccount === null || selectedTeamAccount === void 0 ? void 0 : selectedTeamAccount.dashPass) === null || _b === void 0 ? void 0 : _b.status) ===
        DASHPASS_STATUS.TEAM_ACCOUNT_DASHPASS_SUBSCRIPTION_STATUS_ACTIVE;
    var dynamicValues = useDynamicValues();
    var dashPassForWorkOnboardingEnabled = dynamicValues.getBoolean(DYNAMIC_VALUES_NAME.dashPassForWorkOnboarding, {
        teamId: teamId,
    });
    var searchParams = queryString.parse(useLocation().search);
    var fetchTeamAccountMembersMembers = function () {
        return dispatch(fetchMembers({
            teamAccountId: teamAccountId,
            pageNumber: page,
            pageSize: DEFAULT_PAGE_SIZE,
            includeRoles: true,
            queryString: searchParams.email,
        }));
    };
    var onToggleAdminAccess = function (member, teamAccountId) {
        var teamMemberId = member.id.split('_')[1];
        var action = member.roles && member.roles.includes(Roles.ADMIN)
            ? removeAdminRole
            : addAdminRole;
        return dispatch(action({ teamAccountId: teamAccountId, teamMemberId: teamMemberId }));
    };
    var statusForMembersAction = useSelector(getStatusForMembersAction);
    var currentTeamMember = useSelector(getCurrentTeamMember);
    var members = useSelector(getMembers);
    var pagination = useSelector(getMembersPagination);
    var totalPages = Math.ceil(pagination.totalCount / pagination.pageSize);
    var fetchStatus = (statusForMembersAction[MembersActions.FETCH_MEMBERS] &&
        statusForMembersAction[MembersActions.FETCH_MEMBERS].status) ||
        INITIAL_FETCH_STATUS;
    React.useEffect(function () {
        fetchTeamAccountMembersMembers();
    }, [teamAccountId, page, search]);
    return (React.createElement(AdminMembers, { teamAccountId: teamAccountId, members: members, currentPage: parseInt(page, 10) || 1, currentTeamMember: currentTeamMember, totalCount: pagination.totalCount, totalPages: totalPages, fetchStatus: fetchStatus, fetchMembersContent: fetchTeamAccountMembersMembers, onToggleAdminAccess: onToggleAdminAccess, history: history, searchValue: searchParams.email, teamAccountHasDashPass: dashPassForWorkOnboardingEnabled && hasDashPassForSelectedAccount }));
};
export default withRouter(AdminMembersContainer);
